import {createSite} from '@/api/sites';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import type {CreateSiteRequest} from '@/types/api';

export function useCreateSite() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateSiteRequest) => createSite(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['sites']});
        }
    });
}
